import { z } from 'zod';

export const ExternalTaskSchema = z.object({
  ref: z.string(),
  source: z.enum(['clickup', 'linear']),
  title: z.string(),
  status: z.string(),
  assignee: z.string(),
  url: z.string(),
});
export type ExternalTask = z.infer<typeof ExternalTaskSchema>;
